/**
 * Cookie consent cookie names.
 * Shared between the consent management module and the CookiesBanner UI component.
 */
export const COOKIES_ACCEPTED = 'cookiesAccepted';
export const MARKETING_ACCEPTED = 'marketingAccepted';

export const CONSENT_GRANTED_EVENT = 'tracking:consent-granted';

export enum ConsentCategory {
  Functional = 'functional',
  Marketing = 'marketing',
}
